import { markMobileWarningSeen } from '../utils/deviceDetect.js';

export function showMobileWarning() {
  return new Promise((resolve) => {
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop';
    backdrop.innerHTML = `
      <div class="modal">
        <h2>Мобильное устройство обнаружено</h2>
        <p class="text-muted">
          Тренажёр анализирует скорость и ритм набора. Автокоррекция и подсказки клавиатуры искажают метрики.
        </p>
        <p class="text-muted">Рекомендуется использовать десктоп.</p>
        <p class="text-muted">Если продолжите на мобильном — отключите автокоррекцию и предиктивный ввод.</p>
        <button id="mobile-continue">Понятно, продолжить</button>
      </div>
    `;
    document.body.appendChild(backdrop);
    backdrop.querySelector('#mobile-continue').addEventListener('click', () => {
      markMobileWarningSeen();
      backdrop.remove();
      resolve();
    });
  });
}
